/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { TimesheetEntrySummary } from './TimesheetEntrySummary';
import {
    TimesheetEntrySummaryFromJSON,
    TimesheetEntrySummaryFromJSONTyped,
    TimesheetEntrySummaryToJSON,
    TimesheetEntrySummaryToJSONTyped,
} from './TimesheetEntrySummary';

/**
 * 
 * @export
 * @interface ListTimesheetSummariesResponse
 */
export interface ListTimesheetSummariesResponse {
    /**
     * 
     * @type {Array<TimesheetEntrySummary>}
     * @memberof ListTimesheetSummariesResponse
     */
    data: Array<TimesheetEntrySummary>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListTimesheetSummariesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListTimesheetSummariesResponse interface.
 */
export function instanceOfListTimesheetSummariesResponse(value: object): value is ListTimesheetSummariesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListTimesheetSummariesResponseFromJSON(json: any): ListTimesheetSummariesResponse {
    return ListTimesheetSummariesResponseFromJSONTyped(json, false);
}

export function ListTimesheetSummariesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTimesheetSummariesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TimesheetEntrySummaryFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListTimesheetSummariesResponseToJSON(json: any): ListTimesheetSummariesResponse {
      return ListTimesheetSummariesResponseToJSONTyped(json, false);
  }

  export function ListTimesheetSummariesResponseToJSONTyped(value?: ListTimesheetSummariesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TimesheetEntrySummaryToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

